export default {
  meta: {
    title: '预加载'
  }
};
